export const DEZINFEKCIJA_V1_ResourcesDE: DEZINFEKCIJA_V1_ResourcesBSInterface =
  {
    labelDone: "Datum der Aufgabenerledigung",
    evidencijaForm: {
      buttonForward: "Unterschreiben",
      buttonBack: "Zurück",
    },
    errors: {
      registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
      recordAlreadyExists:
        "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
    },
    successModal: {
      title: "Dateneingabe",
      body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
    profilePicture: {
      label: "Deklarationsbild",
      name: "profilePicture",
      error: "Bitte wählen Sie Ihr Profilbild aus",
      validation: "Falsches Profilbild",
      description: () => (
        <>
          <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
          <span className="text-muted font-13">Nur Bilder, max 6MB</span>
        </>
      ),
    },
    errorMissingInput: "Bitte füllen Sie alle Felder aus",
  };

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface ProfilePicture {
  label: string;
  name: string;
  error: string;
  validation: string;
  description: () => JSX.Element;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DEZINFEKCIJA_V1_ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  profilePicture: ProfilePicture;
  errorMissingInput: string;
  errors: IErrors;
}
